import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePayment } from './usePayment';

export const usePaymentSuccess = () => {
  const navigate = useNavigate();
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const { approvePaymentFromSearchParams } = usePayment();

  const handleApprovePayment = useCallback(async () => {
    try {
      const ok = await approvePaymentFromSearchParams(new URLSearchParams(window.location.search));
      const paymentId = new URLSearchParams(window.location.search).get('paymentId');
      if (!ok) {
        setIsLoading(false);
        navigate('/payment/fail', { replace: true });
        return;
      }
      setIsSuccess(true);
      // 결제 성공 알림: 부모 창에 메시지 전송
      try {
        if (window.opener) {
          window.opener.postMessage(
            {
              type: 'PAYMENT_SUCCESS',
              feature: 'bettie',
              data: {
                paymentId
              }
            },
            window.location.origin
          );
        }
      } catch {
        // noop
      }
    } catch {
      navigate('/payment/fail', { replace: true });
    } finally {
      setIsLoading(false);
    }
  }, [navigate, approvePaymentFromSearchParams]);

  // 승인 호출: 최초 1회만 실행 (StrictMode 이중 호출 방지)
  const hasApprovedRef = useRef(false);
  useEffect(() => {
    if (hasApprovedRef.current) return;
    hasApprovedRef.current = true;
    void handleApprovePayment();
  }, [handleApprovePayment]);

  // 성공 시 2초 후 창 닫기
  useEffect(() => {
    if (!isSuccess) return;
    const timer = setTimeout(() => {
      window.close();
    }, 2000);
    return () => clearTimeout(timer);
  }, [isSuccess]);

  return { isLoading, isSuccess };
};

export default usePaymentSuccess;
